import React from 'react';
import { IAuditoriaDepreciacaoResultado } from '../interfaces/IAuditoriaDepreciacao';
import { TributoAuditoria } from '../interfaces/IAuditoria';
import { formatCurrency } from '../utils/formatters';

interface Props {
  resultado?: IAuditoriaDepreciacaoResultado;
  onSelecionar: (tributo: TributoAuditoria) => void;
}


// Depreciação/Amortização/Exaustão não é um tributo — é uma auditoria complementar de
// paridade contábil entre Ativo e conta redutora. Segue o mesmo padrão de seção própria já
// usado para Saldos Bancários, renderizada abaixo dela no AuditoriaPage.
const AuditoriaResumoDepreciacao: React.FC<Props> = ({ resultado, onSelecionar }) => {
  if (!resultado) {
    return null;
  }

  return (
    <div className='auditoria-card mt-5'>
      <h3>Resumo de Depreciação, Amortização e Exaustão</h3>
      <p className='text-muted'>Auditoria complementar — não é um tributo. Clique para ver a análise detalhada por categoria de ativo.</p>

      <div className='table-responsive mt-4'>
        <table className='auditoria-table auditoria-table-tributos'>
          <thead>
            <tr>
              <th>Auditoria</th>
              <th className='text-end'>Exposição Contábil</th>
              <th className='text-center'>Erros</th>
              <th className='text-center'>Avisos</th>
              <th className='text-center'>Alertas</th>
            </tr>
          </thead>

          <tbody>
            <tr className='auditoria-row-tributo' onClick={() => onSelecionar('DEPRECIACAO_AMORTIZACAO')}>
              <td className='auditoria-col-tributo'>
                <div className='d-flex align-items-center gap-2'>
                  <strong>Auditoria de Depreciação/Amortização/Exaustão</strong>
                  <span className={`auditoria-status status-${resultado.status}`}>
                    {resultado.status}
                  </span>
                </div>
                <div className='auditoria-legislacao-inline'>
                  <div>Paridade entre saldo do Ativo (Imobilizado/Intangível) e movimento da conta redutora</div>
                  <div className='text-muted'>{resultado.mensagemDirecionamento}</div>
                </div>
              </td>
              <td className='text-end auditoria-col-highlight'>
                {formatCurrency(resultado.exposicaoContabilTotal)}
                <div className='auditoria-kpi-help'>Multa ECD potencial (5% limitada a 1% da receita bruta) aplicada somente a ERROs de natureza invertida confirmada</div>
              </td>
              <td className='text-center'>
                <span className='auditoria-contador auditoria-contador-erro'>{resultado.totalErros}</span>
              </td>
              <td className='text-center'>
                <span className='auditoria-contador auditoria-contador-aviso'>{resultado.totalAvisos}</span>
              </td>
              <td className='text-center'>
                <span className='auditoria-contador auditoria-contador-alerta'>{resultado.totalAlertas}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AuditoriaResumoDepreciacao;
